export enum RelationWithTool {
  AffiliatedWithTool = 'AffiliatedWithTool',
  ToolUser = 'ToolUser',
  HeardOfTool = 'HeardOfTool'
}
